<div class="menu-grid-container">
  <div
    class="glass-blurred-background menu-box center-content"
    (click)="openPage('/my-investments')"
  >
    <img class="block-image svg-white" src="./assets/imgs/investimenti.svg" />
    <h2 class="text-center">
      MIEI <br />
      <div class="wrap-text">INVESTIMENTI</div>
    </h2>
  </div>
  <div
    class="glass-blurred-background menu-box center-content"
    (click)="openPage('/news')"
  >
    <img class="block-image svg-white" src="./assets/imgs/news.svg" />
    <h2 class="text-center">NEWS</h2>
  </div>

  <div
    class="glass-blurred-background menu-box center-content"
    (click)="openPage('/products')"
  >
    <img class="block-image svg-white" src="./assets/imgs/prodotti.svg" />
    <h2 class="text-center">
      PRODOTTI <br />
      <div class="wrap-text">AZIENDALI</div>
    </h2>
  </div>
</div>
<!--
chiedi chiuso aperto -->
